import { Button } from '@/shared/components/ui/button';
import { MembershipRole } from '@/types/api/membership';
import { Link, useParams } from 'react-router-dom';
import { useGroupSuspense } from '../api/get-group';
import { InviteMembers } from '@/features/invites/components/invite-members';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { paths } from '@/config/paths';
import { useOnboardingPrefs } from '../stores/onboarding-prefs.store';
import { OnboardingGoal } from '../component/onboarding/onboarding-goal';
import { GroupContextGate } from '../component/group-context-gate';

const createTitle = (name: string) => `Grattis! ${name} är skapad 🔥`;
const MESSAGE = 'Nästa steg: bjud in deltagare, registrera utbetalningskonto och starta försäljningen.';

export function GroupRegistered() {
  const groupId = useParams().groupId!;

  return (
    <GroupContextGate groupId={groupId}>
      <Registered groupId={groupId} />
    </GroupContextGate>
  );
}

function Registered({ groupId }: { groupId: string }) {
  const { data } = useGroupSuspense({ groupId });
  const prefs = useOnboardingPrefs(groupId);

  return (
    <div className="flex flex-col items-center gap-8 p-4 max-w-md mx-auto">
      <CheckCircle2 className="size-16 text-emerald-400" />

      <h2 className="text-2xl font-bold text-center">{createTitle(data?.name!)}</h2>

      <OnboardingGoal prefs={prefs} />

      <p className="text-center">{MESSAGE}</p>

      <div className="flex gap-4 flex-col w-full md:w-auto md:flex-row">
        <Button asChild>
          <Link to={paths.group.onboarding.getHref()}>
            Fortsätt till Kom igång <ArrowRight />
          </Link>
        </Button>
        <InviteMembers roles={[MembershipRole.Member]} orgId={groupId} variant={'outline'} />
      </div>
    </div>
  );
}
